import { Crop } from 'react-image-crop';
import { CropOptions, ImageAttributes } from 'types/general.types';
import { useState } from 'react';

export const useCropOptions = (imageAttributes: ImageAttributes) => {
  const [cropOptions, setCropOptions] = useState<CropOptions>();

  const updateCropOptions = (crop: Crop) => {
    if (
      crop.x !== undefined &&
      crop.y !== undefined &&
      crop.width &&
      crop.height
    ) {
      setCropOptions({
        left: Math.floor(crop.x),
        top: Math.floor(crop.y),
        width: Math.floor(crop.width),
        height: Math.floor(crop.height),
      });
    } else {
      const minDimension = Math.min(
        imageAttributes.width,
        imageAttributes.height
      );
      setCropOptions({
        left: Math.floor((imageAttributes.width - minDimension) / 2),
        top: Math.floor((imageAttributes.height - minDimension) / 2),
        width: Math.floor(minDimension),
        height: Math.floor(minDimension),
      });
    }
  };

  const calculateCropOptions = (
    cropOptions: CropOptions,
    image: ImageAttributes
  ) => {
    const scaleFactor = image.height / image.naturalHeight;
    const offsetXCoordinate =
      (image.naturalWidth - image.width / scaleFactor) / 2;
    const width = Math.floor(cropOptions.width / scaleFactor);
    const height = Math.floor(cropOptions.height / scaleFactor);
    const allowedDimension = Math.min(image.naturalWidth, image.naturalHeight);

    return {
      left: Math.max(
        0,
        Math.floor(cropOptions.left / scaleFactor + offsetXCoordinate)
      ),
      top: Math.max(0, Math.floor(cropOptions.top / scaleFactor)),
      width: width > allowedDimension ? allowedDimension : width,
      height: height > allowedDimension ? allowedDimension : height,
    };
  };

  return { updateCropOptions, calculateCropOptions, cropOptions };
};
